import { auth, db } from "../../firebase";
import {
  collection, query, where, orderBy, getDocs, addDoc, 
  doc, updateDoc, deleteDoc, writeBatch, serverTimestamp
} from "firebase/firestore";

const groupsCol = collection(db, "space_groups"); // 🌟 Isolated Collection
const tasksCol = collection(db, "space_tasks");

export async function getSpaceGroups(spaceId) {
  const q = query(groupsCol, where("spaceId", "==", spaceId), orderBy("name"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function createSpaceGroup(spaceId, groupData) {
  const user = auth.currentUser;
  const trimmedName = groupData.name.trim();

  // Uniqueness check within the same space and level
  const checkQ = query(
    groupsCol,
    where("spaceId", "==", spaceId),
    where("name", "==", trimmedName),
    where("parentId", "==", groupData.parentId || null)
  );
  const existing = await getDocs(checkQ);
  if (!existing.empty) throw new Error("A group with this name already exists here.");

  const docRef = await addDoc(groupsCol, {
    name: trimmedName,
    spaceId: spaceId,
    parentId: groupData.parentId || null,
    userId: user.uid,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  });

  return { id: docRef.id };
}

export async function updateSpaceGroup(groupId, spaceId, oldName, newData) {
  const batch = writeBatch(db);
  const groupRef = doc(db, "space_groups", groupId);
  
  batch.update(groupRef, {
    name: newData.name.trim(),
    parentId: newData.parentId || null,
    updatedAt: serverTimestamp()
  });

  // Rename tasks belonging to this group name within the same space
  if (oldName !== newData.name.trim()) {
    const q = query(tasksCol, where("spaceId", "==", spaceId), where("group", "==", oldName));
    const taskSnap = await getDocs(q);
    taskSnap.forEach((tDoc) => {
      batch.update(tDoc.ref, { group: newData.name.trim() });
    });
  }
  await batch.commit();
}

export async function deleteSpaceGroupAndTasks(groupId, spaceId, groupName) {
  const batch = writeBatch(db);
  batch.delete(doc(db, "space_groups", groupId));

  const q = query(tasksCol, where("spaceId", "==", spaceId), where("group", "==", groupName));
  const taskSnap = await getDocs(q);
  taskSnap.forEach((tDoc) => {
    batch.delete(tDoc.ref);
  });

  await batch.commit();
}
